// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_FnK","cls2":"CiterightMiniReport-cls2_AC3 CiterightMiniReport-cls1_FnK"};